import { render, staticRenderFns } from "./default_form.vue?vue&type=template&id=6b232776&lang=pug&"
import script from "./default_form.vue?vue&type=script&lang=js&"
export * from "./default_form.vue?vue&type=script&lang=js&"
import style0 from "./default_form.vue?vue&type=style&index=0&id=6b232776&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports